// export const BASE_URL = "http://localhost:8080/lhb-core";
//site key for google captcha
export const REACT_APP_SITE_KEY = "6LegAzwtAAAAALjgF9b9OuB-mVrxaYhQvdJ0Xv_Q";

//staging url
// export const BASE_URL = "https://api.scalent.in/lhb-core";

//prod URL
 export const BASE_URL = "https://lhbapi.raychemrpg.com/lhb-core";

// login API
export const LOGIN = `${BASE_URL}/login`;

// logout API
export const LOGOUT = `${BASE_URL}/logout`;

//unit component
export const UNIT = `${BASE_URL}/unit/`;
export const UNIT_LIST = `${BASE_URL}/unit/list`;

//user
export const USER = `${BASE_URL}/user/`;
export const USER_LIST = `${BASE_URL}/user/list`;

//department
export const DEPARTMENT = `${BASE_URL}/department/`;
export const DEPARTMENT_LIST = `${BASE_URL}/department/list`;

//customer
export const CUSTOMER = `${BASE_URL}/customer/`;
export const CUSTOMER_LIST = `${BASE_URL}/customer/list`;

//duty type
export const DUTY_TYPE = `${BASE_URL}/duty-type/`;
export const DUTY_TYPE_LIST = `${BASE_URL}/duty-type/list`;

//role
export const ROLE = `${BASE_URL}/role/`;
export const ROLE_LIST = `${BASE_URL}/role/list`;

//shift
export const SHIFT = `${BASE_URL}/shift/`;
export const SHIFT_LIST = `${BASE_URL}/shift/list`;

//station
export const STATION = `${BASE_URL}/station/`;
export const STATION_LIST = `${BASE_URL}/station/list`;

//subactivity
export const SUBACTIVITY = `${BASE_URL}/sub-activity/`;
export const SUBACTIVITY_LIST = `${BASE_URL}/sub-activity/list`;
export const SUBACTIVITY_UNIQUE_LIST = `${BASE_URL}/sub-activity/unique-list`;
// export csv file of subactivity
export const EXPORT_SUBACTIVITY_CSV = `${BASE_URL}/sub-activity/export`;

//micro activity
export const MICROACTIVITY = `${BASE_URL}/micro-activity/`;
export const MICROACTIVITY_LIST = `${BASE_URL}/micro-activity/list`;
export const MICROACTIVITY_UNIQUE_LIST = `${BASE_URL}/micro-activity/unique-list`;
// export csv file of microactivity
export const EXPORT_MICROACTIVITY_CSV = `${BASE_URL}/micro-activity/export`;

//product
export const PRODUCT = `${BASE_URL}/product/`;
export const PRODUCT_LIST = `${BASE_URL}/product/list`;

//project
export const PROJECT = `${BASE_URL}/project/`;
export const PROJECT_LIST = `${BASE_URL}/project/list`;
// export csv file of project
export const EXPORT_PROJECT_CSV = `${BASE_URL}/project/export`;

//remark
export const REMARK = `${BASE_URL}/remark/`;
export const REMARK_LIST = `${BASE_URL}/remark/list`;

//change password
export const CHANGE_PASSWORD = `${BASE_URL}/user/change-password`;

//technician
export const TECHNICIAN = `${BASE_URL}/technician/`;
export const TECHNICIAN_LIST = `${BASE_URL}/technician/list`;
// export csv file of technician
export const EXPORT_TECHNICIAN_CSV = `${BASE_URL}/technician/export`;

//forget password
export const FORGET = `${BASE_URL}/forget`;

//validate uuid:
export const VALIDATE_UUID_LINK = `${BASE_URL}/validate-link/`;

//reset-password
export const RESET_PASSWORD = `${BASE_URL}/reset-password`;

//contractot
export const CONTRACTOR_LIST = `${BASE_URL}/contractor/list`;
export const CONTRACTOR = `${BASE_URL}/contractor/`;

//timesheet
export const TIMESHEET_LIST = `${BASE_URL}/timesheet/list`;
export const TIMESHEET = `${BASE_URL}/timesheet/`;

//lhb records
export const LHB_RECORDS = `${BASE_URL}/lhb-record/`;
//designation
export const DESIGNATION_LIST = `${BASE_URL}/designation/list`;

//dashboard
export const DASHBOARD = `${BASE_URL}/dashboard/reports`;

export const PLANT_HEAD_DASHBOARD = `${BASE_URL}/dashboard/plant-head/reports`;

export const SUPERVISOR_DASHBOARD = `${BASE_URL}/dashboard/supervisor/reports`;

export const PLANNING_DASHBOARD = `${BASE_URL}/dashboard/planning/reports`;

export const IE_DASHBOARD = `${BASE_URL}/dashboard/industrial/reports`;

export const ADMIN_DASHBOARD = `${BASE_URL}/dashboard/admin/reports`;

//reports
export const PENDING_SUBMISSIONS = `${BASE_URL}/reports/timesheets/pending-submissions`;
export const EXPORT_PENDING_SUBMISSIONS_CSV = `${BASE_URL}/reports/timesheets/pending-submissions/export`;

export const EMPLOYEE_PRODUCTIVITY = `${BASE_URL}/reports/employee-productivity`;
export const EXPORT_EMPLOYEE_PRODUCTIVITY_CSV = `${BASE_URL}/reports/employee-productivity/export`;

export const INDUSTRIAL_REPORT = `${BASE_URL}/reports/industrial-report`;
export const EXPORT_INDUSTRIAL_REPORT_CSV = `${BASE_URL}/reports/industrial-report/export`;

export const PLANNING_REPORT = `${BASE_URL}/reports/planning-report`;
export const EXPORT_PLANNING_REPORT_CSV = `${BASE_URL}/reports/planning-report/export`;

export const USERS_SYSTEM_REPORT = `${BASE_URL}/reports/users-system-report`;
export const EXPORT_USERS_SYSTEM_REPORT_CSV = `${BASE_URL}/reports/users-system-report/export`;

export const MASTER_CHANGE_LOG_REPORT = `${BASE_URL}/reports/master-change-log-report`;
export const EXPORT_MASTER_CHANGE_LOG_REPORT_CSV = `${BASE_URL}/reports/master-change-log-report/export`;

export const EMPLOYEE_EFFICIENCY_REPORT = `${BASE_URL}/reports/employee-efficiency-report`;
export const EXPORT_EMPLOYEE_EFFICIENCY_REPORT_CSV = `${BASE_URL}/reports/employee-efficiency-report/export`;
